import { connect } from 'react-redux';
import Loading from './Loading';

const mapStateToProps = state => ({
  isLoading: state.estimateBuilder.uiState.isLoading,
});

export default connect(mapStateToProps)(Loading);
